import React from 'react';
import {MarkColor} from '../../../diagnosticReporting/Styles';

//contrast checked for background colors with white texts for AA WCAG standards
export const SelfAssessmentMarkColor = {
    notSubmitted: '#888888',
    submitted:'#B260AE',
    notConfident: MarkColor.INCORRECT,
    unsure: '#B3611E',
    confident: '#8C7F00',
    veryConfident: '#288132',
}

const SelfAssessmentLegend = props => {
    const {heading} = props;

    const BlockWithKeyText = props =>{
        const {blockColor, ariaLabel = '', text, rectWidth = '22px', rectHeight = '22px', minElemWidth = '150px'} = props;

        return (<div className='flex flex1 smallGap' role={'list'} aria-label={ariaLabel}>
                    <div className='flex flexCentre flexAlignCentre smallGap' role={"listitem"} style={{
                        backgroundColor: blockColor,
                        borderRadius:'4px',
                        width: rectWidth,
                        height: rectHeight
                    }}></div>
                    <div className={'no-wrap'}>{text}</div>
                </div>);
        }


    return (
        <div className={'flex flexCentre'}>
            <div className='flexColumn padding--m padding-t--s padding-b--l ch-emph-block'>
                <div className='flexWrap flexCentre margin-b--m'>
                    <h2 className={'ch-std-font'} aria-label={'legend for '+heading+' key'}>{heading} key</h2>
                </div>
                <div className='flexWrap flexCentre flexAlignCentre largeGap' style={{lineHeight: '22px'}}>
                    <BlockWithKeyText ariaLabel={'Grey block representing not submitted'} text={'Not submitted'} blockColor={SelfAssessmentMarkColor.notSubmitted}/>
                    <BlockWithKeyText ariaLabel={'Violet block representing submitted'} text={'Unassessed'} blockColor={SelfAssessmentMarkColor.submitted}/>
                    <BlockWithKeyText ariaLabel={'Red block representing not confident'} text={'Not confident'} blockColor={SelfAssessmentMarkColor.notConfident}/>
                    <BlockWithKeyText ariaLabel={'Yellow block representing unsure'} text={'Unsure'} blockColor={SelfAssessmentMarkColor.unsure}/>
                    <BlockWithKeyText ariaLabel={'Orange block representing confident'} text={'Confident'} blockColor={SelfAssessmentMarkColor.confident}/>
                    <BlockWithKeyText ariaLabel={'Green block representing very confident'} text={'Very confident'} blockColor={SelfAssessmentMarkColor.veryConfident}/>
                </div>
            </div>
        </div>
    )
}

export default SelfAssessmentLegend;